// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"667":"ede38e09","977":"c0bceeab"}[chunkId] + ".chunk.js";
};